module.exports = {"532626101":"锦屏镇","532626102":"曰者镇","532626103":"双龙营镇","532626201":"八道哨彝族乡","532626202":"天星乡","532626203":"平寨乡","532626204":"树皮彝族乡","532626205":"腻脚彝族乡","532626206":"新店彝族乡","532626207":"舍得彝族乡","532626208":"官寨乡","532626209":"温浏乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532626.json
// module id = 2778
// module chunks = 0